import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { BehaviorSubject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class AccessibilityService {
  private showSkipLinkSubject = new BehaviorSubject<boolean>(false);
  showSkipLink$ = this.showSkipLinkSubject.asObservable();

  constructor(private router: Router) {
  }

  handleKeyDown(navigateTo: string, queryParams?: Record<string, string>) {
    this.router.navigate([navigateTo], queryParams ? { queryParams } : undefined);
  }

  updateShowSkipLink(value: boolean) {
    this.showSkipLinkSubject.next(value);
  }

}
